module.exports = __webpack_public_path__ + "img/ran.4c53c096.jpeg";